/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import { IAny } from '../../components/DashboardKPIWidgets/IEnergyManagementProps';
import BaselineConfigActions from './BaselineConfigActions';

interface IAction {
  type: string;
  payload?: IAny;
}

const baselineConfigReducer = (state: IAny, action: IAction) => {
  switch (action.type) {
    case BaselineConfigActions.UPDATE_FORM_DATA:
      return {
        ...state,
        formData: {
          ...state.formData,
          [action.payload.key]: {
            ...state.formData[action.payload.key],
            ...action.payload.value
          }
        }
      };
    case BaselineConfigActions.INITIALIZE_FORM_DATA:
      return {
        ...state,
        formData: action.payload
      };
    case BaselineConfigActions.RESET_FORM_DATA:
      return {
        ...state,
        formData: {}
      };
    default:
      return state;
  }
};

export default baselineConfigReducer;
